export default "__VITE_ASSET__ClZZy_cm__"